;$(function() {

	$('.categories__show-more').click(function() {
		$(this).remove();
	});

});